import { HStack, IconWarning } from '@montel/montelpro-shared-components-v2';
import { EllipsisText } from 'components/tables/EllipsisText';
import { FunctionComponent } from 'react';
import { styled } from 'styled-components';
import { Email as IEmail } from 'domain/account/interfaces';
import { v4 as uuidv4 } from 'uuid';
import { TableFriendlyTooltip } from 'components/tables/TableFriendlyTooltip';

interface EmailProps {
	email: IEmail;
	align?: 'flex-start' | 'center' | 'flex-end';
	fontSize?: 'sm' | 'md' | 'lg';
}

const IconWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const Email: FunctionComponent<EmailProps> = ({
	email,
	align = 'center',
	fontSize = 'sm',
}) => {
	const tooltipId = uuidv4().replaceAll('-', '');

	return (
		<HStack align={align} wrap="nowrap">
			{!email.verified && (
				<IconWrapper>
					<IconWarning
						size="sm"
						color="bgError"
						data-tooltip-id={tooltipId}
						data-tooltip-content={'Unverified email address'}
					/>
					<TableFriendlyTooltip id={tooltipId} maxWidth={160} />
				</IconWrapper>
			)}
			<EllipsisText as={'span'} size={fontSize}>
				{email.value || 'N/A'}
			</EllipsisText>
		</HStack>
	);
};
